<app-element-loader
  [loadingStatus]="this.isLoading"
  [loadingMessage]="'Stiamo caricando i prezzi aggiornati'">
</app-element-loader>

<ng-container *ngIf="!isLoading">
  <div class="detail-recap">
    <div class="detail-recap__header">
      <div class="detail-recap__occupancy">

        <ng-container
          *ngIf="!(selectedDepartureDate && !this.validSolutionsFound) && (this.bestPriceAmongAvailableSolutions || this.fallbackPrice)">
          <!-- prezzo 'a partire da' -->
          <span>a partire da </span>
          <span
            class="detail-recap__price">&euro; {{ (this.bestPriceAmongAvailableSolutions || this.fallbackPrice) | number: '1.0-0'}}</span>
        </ng-container>

        <ng-container *ngIf="allSolutionForSelectedDate.length < 1 && brand?.detailPageConfig?.showPriceGrid">
          <h5 class="mb-2">Nessuna soluzione disponibile</h5>
          <a *ngIf="brand?.networkId === wtgNetworkId"
            #editGuestsRef
            (click)="openEngineGuestsModal()"
            class="detail-recap__change-guests">
            Modifica passeggeri
          </a>
        </ng-container>
      </div>

    </div>

    <ng-container *ngIf="!brand?.detailPageConfig?.showPriceGrid">
      <div class="detail-recap__body">

        <!-- Destinazione -->
        <div class="detail-recap__row detail-recap__destination">
          <div class="detail-recap__icon">
            <i class="icon-pin"></i>
          </div>
          <div class="detail-recap__text">
            {{destinationName}}
          </div>
        </div>

        <!-- Date -->
        <div class="detail-recap__row">
          <div class="detail-recap__icon">
            <i class="icon-calendar"></i>
          </div>
          <div class="detail-recap__text">
            <ng-container *ngIf="this.selectedDepartureDate">
              {{ this.selectedDepartureDate | date }}
            </ng-container>
            <ng-container *ngIf="!this.selectedDepartureDate">
              <strong>{{ this.allAvailableDates?.length }}</strong> <span> date disponibili</span>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="!this.brand?.detailPageConfig?.showPriceGrid">
          <p *ngIf="!this.selectedDepartureDate">
            <span class="u-text--link" (click)="this.onClickOnChooseDate()">Scegli una data</span> per conoscere
            disponibilità e prezzi
          </p>
        </ng-container>

        <!-- Solo GEO no-WTG  -->
        <ng-container *ngIf="!this.brand?.detailPageConfig?.showPriceGrid">
          <p *ngIf="this.selectedDepartureDate && this.validSolutionsFound > 0">
            Abbiamo trovato <span class="u-text--link"
                                  (click)="this.onClickOnChooseSolution()">{{this.validSolutionsFound}}
            soluzion{{ this.validSolutionsFound === 1 ? 'e' : 'i'}}</span>
            disponibil{{ this.validSolutionsFound === 1 ? 'e' : 'i'}} per
            il {{this.selectedDepartureDate | date }}.
          </p>
          <p *ngIf="this.selectedDepartureDate && !this.validSolutionsFound">
            Nessuna soluzione disponibile il {{this.selectedDepartureDate | date }} per {{this.formattedGuestsString}}.
            Prova ad eseguire una nuova ricerca.
          </p>
        </ng-container>

      </div>

      <!-- Pulsante Condividi -->
      <div class="detail-recap__share">
        <a target="_blank"
           class="detail-recap__share__button detail-recap__cta__button btn btn--blue-outline text-lowercase"
           href="https://www.facebook.com/sharer/sharer.php?u={{this.location}};src=sdkpreparse">
          <i class="icon-facebook detail-recap__share__icon"></i>
          <span class="detail-recap__share__text">Condividi</span>
        </a>
      </div>

      <div class="detail-recap__footer">
        <div class="detail-recap__row detail-recap__cta__wrapper">

          <ng-container *ngIf="!this.selectedDepartureDate">
            <a class="detail-recap__cta__button btn btn--brand-color-03" href="javascript:void(null)"
               (click)="this.onClickOnChooseDate()">
              Scegli Data
            </a>
          </ng-container>

          <ng-container *ngIf="this.selectedDepartureDate">
            <a class="detail-recap__cta__button btn btn--brand-color-03"
               [class.disabled]="this.selectedDepartureDate && !this.validSolutionsFound"
               href="javascript:void(null)"
               (click)="this.onClickOnChooseSolution()">
              Scegli Partenza
            </a>
          </ng-container>

        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
